import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  Typography,
  LinearProgress,
  Card,
  CardContent
} from '@mui/material';
import { dateToString } from '../../shared/formatters';

const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderRadius: '16px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  '&:hover': {
    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.12)',
    transform: 'translateY(-2px)',
  },
  '&:active': {
    transform: 'scale(0.98)',
  },
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(3),
  '&:last-child': {
    paddingBottom: theme.spacing(3),
  },
}));

const StyledLinearProgress = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== 'barcolor',
})(({ barcolor }) => ({
  height: '12px',
  borderRadius: '8px',
  backgroundColor: 'rgba(0, 0, 0, 0.08)',
  '& .MuiLinearProgress-bar': {
    backgroundColor: barcolor || '#4caf50',
    borderRadius: '8px',
  },
}));

function showTransactions(categoryId,date, updateTransactionFilters, navigate) {
  var dateSplit = date.split('/');
  if (!!date[1]) {
    var month = parseInt(dateSplit[0]) - 1;
    var year = parseInt(dateSplit[1]);
    const searchFilters = {
      description: '',
      categories: [categoryId],
      financeAccounts: [],
      users: [],
      from: dateToString(new Date(year, month, 1)),
      to: dateToString(new Date(year, month + 1, 0))
    };
    updateTransactionFilters(searchFilters);
    navigate('/transactions');
  }
};

const calculateProgressInMonth = (month) => {
    if (!month) return 100;
    
    const dateSplit = month.split('/');
    const searchMonth = parseInt(dateSplit[0]) - 1;
    const searchYear = parseInt(dateSplit[1]);
    
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();
    
    // Check if the searched month is the current month
    if (searchMonth === currentMonth && searchYear === currentYear) {
      const currentDay = today.getDate();
      const totalDaysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
      return (currentDay / totalDaysInMonth) * 100;
    }
    
    return 100; // For past or future months, return 100%
  };
  

const CategoryProgressCard = ({ categoryId, name, spent, goal, month, updateTransactionFilters, navigate }) => {
  const progress = (spent / goal) * 100;
  const progressInMonth = calculateProgressInMonth(month);

  // Calculate bar color based on progress relative to progressInMonth
  const getBarColor = () => {
    if (progress > progressInMonth * 1.1) {
      return '#c62828'; 
    } else if (progress >= progressInMonth * 0.9) {
      return '#ff9800'; 
    } else {
      return '#4caf50'; 
    }
  };

  const barColor = getBarColor();

  return (
    <StyledCard onClick={() => showTransactions(categoryId, month, updateTransactionFilters, navigate)}>
      <StyledCardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" component="div" sx={{ fontWeight: 700, color: '#1a1a1a' }}>
            {name}
          </Typography>
          <Typography variant="subtitle1" component="div" sx={{ fontWeight: 600, color: '#666' }}>
            R$ {spent.toFixed(2)} / R$ {goal.toFixed(2)}
          </Typography>
        </Box>

        <Box sx={{ position: 'relative', width: '100%' }}>
          <StyledLinearProgress 
            variant="determinate" 
            value={progress > 100 ? 100 : progress} 
            barcolor={barColor}
          />
          {progressInMonth < 100 && (
            <Box
              sx={{
                position: 'absolute',
                left: `${progressInMonth}%`,
                top: 0,
                height: '12px',
                width: '3px',
                backgroundColor: '#2196f3',
                boxShadow: '0 0 6px rgba(33, 150, 243, 0.6)',
                zIndex: 1,
                transform: 'translateX(-1.5px)',
                borderRadius: '2px',
              }}
            />
          )}
        </Box>
      </StyledCardContent>
    </StyledCard>
  );
};

export default CategoryProgressCard;